import React from 'react';
import { makeStyles, Icons } from '~/lib/bn-material-ui';
import baseStyles from './base-styles';

const useStyles = makeStyles((theme) =>
  baseStyles(theme.palette.yellow[10], theme.palette.yellow[20]),
);

export default function Unmonitored() {
  const styles = useStyles();
  return (
    <div className={styles.bar}>
      <Icons.PortableWifiOff className={styles.icon} />
      <span>
        <strong>Standard: </strong>Bin levels are based on manual inventories and consumption and
        are <strong>not verified</strong> by BinSentry.
      </span>
    </div>
  );
}
